import {API_URL, apiPost, apiPut} from '../api'

export const editPromotion = async (id, data) => {
    return await apiPut(API_URL, `admin/promotion/${id}`, data)
}
